import BaseServiceHttp from '../baseService'
class Exportacao extends BaseServiceHttp {
  constructor(id) {
    const resource = 'importacao'
    const relationship = {
      arquivosPlagios: 'arquivos-plagios'
    }
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }

  ArquivosPlagios(filter) {
    return this._http.post(
      'https://apps.viacometa.com.br/api/leitura/importacao/arquivos-plagios',
      filter,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  }
}

export default id => new Exportacao(id)
